<template>
  <div class="cooperation-my-accounts-change-cp-container">
    <div class="accounts-text-container" @click="handDetail">
      <div class="accounts-title-banner">
        <span class="left-title" style="line-height:1.5">{{
          item.pactName
        }}</span>
      </div>
      <div class="accounts-text-content">
        <span>所属项目：</span>
        <span>{{ item.projname }}</span>
      </div>
      <div class="accounts-text-content">
        <span>所属公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div class="accounts-text-content">
        <span>合同编号：</span>
        <span>{{ item.pactCode }}</span>
      </div>
      <div class="accounts-text-content">
        <span>合同签约金额：</span>
        <span>{{ item.htamountzBz | money2 }}</span>
      </div>
      <div class="accounts-text-content">
        <span>结算日期：</span>
        <span>{{
          item.balanceDate && moment(item.balanceDate).format('YYYY-MM-DD')
        }}</span>
      </div>
    </div>
    <div class="accounts-info-box">
      <div class="accounts-info-item">
        结算申报金额：{{ item.yfapplyamount | money2 }}
      </div>
      <div class="accounts-info-item">
        结算审定金额：{{ item.totalamount | money2 }}
      </div>
      <!-- <div class="accounts-info-item">
        结算调整金额：<span style="color: #36C392">{{
          item.adjustamount | money2
        }}</span>
      </div> -->
      <div class="accounts-info-item">
        保修金额：<span style="color:#C18858 ">{{
          item.bxamount | money2
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-my-accounts-change-cp',

  data() {
    return {
      moment
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},

  components: {},

  methods: {
    handDetail() {
      let { item } = this;
      let { employeeName, mobile } = getUrlParams();
      let { contractguid } = item;
      this.$router.push({
        name: 'cooperationDetail',
        query: {
          contractguid,
          index: 3,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-my-accounts-change-cp-container {
  padding-bottom: 30px;
  .accounts-text-container {
    padding: 20px;
    .accounts-title-banner {
      position: relative;
      .left-title {
        width: 100%;
        color: #000000;
        font-size: 28px;
        display: inline-block;
      }
      .right-icon {
        width: 120px;
        height: 40px;
        font-size: 22px;
        color: white;
        line-height: 40px;
        text-align: center;
        background: #36c490;
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
    .accounts-text-content {
      font-size: 26px;
      margin-top: 10px;
      display: flex;
      span:nth-child(1) {
        min-width: 140px;
        display: inline-block;
        line-height: 1.5;
        color: #999;
      }
      span:nth-child(2) {
        color: #666666;
        flex: 1;
        line-height: 1.5;
        max-width: 100%;
      }
    }
  }
  .accounts-info-box {
    height: 130px;
    margin-top: 20px;
    width: 100%;
    display: flex;
    margin-left: 20px;
    background: rgba(239, 239, 239, 0.38);
    flex-wrap: wrap;
    font-size: 26px;
    padding-right: 20px;
    .accounts-info-item {
      color: #666666;
      text-align: left;
      padding-left: 20px;
      line-height: 65px;
      width: 50%;
    }
  }
}
</style>
<style lang="scss">
.cooperation-my-accounts-change-cp-container {
}
</style>
